import { Table } from "@/features/Table";
import { useTranslation } from "react-i18next";
import { L1EventRow, useL1EventColumns } from "./columns";
import { FilterL1Events, type FilterL1EventsSchema } from "./filter";

const client = "l1";
const table_name = "l1_events";

export function L1EventsTable() {
  const { t } = useTranslation();
  const columns = useL1EventColumns();

  return (
    <Table<L1EventRow, FilterL1EventsSchema>
      label={t(`${table_name}.title`, { ns: "tables", defaultValue: "Events" })}
      client={client}
      table_name={table_name}
      columns={columns}
      columnVisibilityInit={{ created_at: false, updated_at: false }}
      filter={<FilterL1Events />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
}
